import {
  timelineCalculating,
  timeListCalculating
} from '../../../utils/meetingTimeline'
import { getWeekArray, addDays } from '../../../utils/dateUtils'
/**
|--------------------------------------------------
| Constants
|--------------------------------------------------
*/
export const ROOM_LIST_REQUEST = 'MeetingRoom/ROOM_LIST_REQUEST'
export const ROOM_LIST_SUCCESS = 'MeetingRoom/ROOM_LIST_SUCCESS'
export const ROOM_LIST_FAILURE = 'MeetingRoom/ROOM_LIST_FAILURE'

export const DELETE_REPEAT_MEETING_ROOM_REQUEST =
  'MeetingRoom/DELETE_REPEAT_MEETING_ROOM_REQUEST'
export const DELETE_REPEAT_MEETING_ROOM_SUCCESS =
  'MeetingRoom/DELETE_REPEAT_MEETING_ROOM_SUCCESS'
export const DELETE_REPEAT_MEETING_ROOM_FAILURE =
  'MeetingRoom/DELETE_REPEAT_MEETING_ROOM_FAILURE'

export const BOOKING_LIST_REQUEST = 'MeetingRoom/BOOKING_LIST_REQUEST'
export const BOOKING_LIST_FAILURE = 'MeetingRoom/BOOKING_LIST_FAILURE'
export const BOOKING_LIST_SUCCESS = 'MeetingRoom/BOOKING_LIST_SUCCESS'

export const BOOKING_DETAIL_REQUEST = 'MeetingRoom/BOOKING_DETAIL_REQUEST'
export const BOOKING_DETAIL_FAILURE = 'MeetingRoom/BOOKING_DETAIL_FAILURE'
export const BOOKING_DETAIL_SUCCESS = 'MeetingRoom/BOOKING_DETAIL_SUCCESS'

export const SET_START_TIME = 'MeetingRoom/SET_START_TIME'
export const UNSET_START_TIME = 'MeetingRoom/UNSET_START_TIME'
export const SET_END_TIME = 'MeetingRoom/SET_END_TIME'
export const UNSET_END_TIME = 'MeetingRoom/UNSET_END_TIME'

export const CHANGE_MEETING_ROOM = 'MeetingRoom/CHANGE_MEETING_ROOM'
export const CHANGE_BOOKING_DATE = 'MeetingRoom/CHANGE_BOOKING_DATE'

export const INTERNAL_MEMBER_INVITE = 'MeetingRoom/INTERNAL_MEMBER_INVITE'
export const INTERNAL_MEMBER_REMOVE = 'MeetingRoom/INTERNAL_MEMBER_REMOVE'

export const EXTERNAL_MEMBER_INVITE = 'MeetingRoom/EXTERNAL_MEMBER_INVITE'
export const EXTERNAL_MEMBER_REMOVE = 'MeetingRoom/EXTERNAL_MEMBER_REMOVE'

export const EMPLOYEES_PROFILE_REQUEST = 'MeetingRoom/EMPLOYEES_PROFILE_REQUEST'
export const EMPLOYEES_PROFILE_FAILURE = 'MeetingRoom/EMPLOYEES_PROFILE_FAILURE'
export const EMPLOYEES_PROFILE_SUCCESS = 'MeetingRoom/EMPLOYEES_PROFILE_SUCCESS'

export const BOOKING_CREATE_REQUEST = 'MeetingRoom/BOOKING_CREATE_REQUEST'
export const BOOKING_CREATE_FAILURE = 'MeetingRoom/BOOKING_CREATE_FAILURE'
export const BOOKING_CREATE_SUCCESS = 'MeetingRoom/BOOKING_CREATE_SUCCESS'

export const BOOKING_UPDATE_REQUEST = 'MeetingRoom/BOOKING_UPDATE_REQUEST'
export const BOOKING_UPDATE_FAILURE = 'MeetingRoom/BOOKING_UPDATE_FAILURE'
export const BOOKING_UPDATE_SUCCESS = 'MeetingRoom/BOOKING_UPDATE_SUCCESS'

export const INITIALIZE_ROOM_BOOKING = 'MeetingRoom/INITIALIZE_ROOM_BOOKING'

export const BOOKING_DELETE_REQUEST = 'MeetingRoom/BOOKING_DELETE_REQUEST'
export const BOOKING_DELETE_FAILURE = 'MeetingRoom/BOOKING_DELETE_FAILURE'
export const BOOKING_DELETE_SUCCESS = 'MeetingRoom/BOOKING_DELETE_SUCCESS'

export const GENERATE_WEEK_ARRAY = 'MeetingRoom/GENERATE_WEEK_ARRAY'

export const CHANGE_BOOKING_VIEW_TYPE = 'MeetingRoom/CHANGE_BOOKING_VIEW_TYPE'

export const CONSTANTS = {
  ROOM_LIST_REQUEST,
  ROOM_LIST_SUCCESS,
  ROOM_LIST_FAILURE,
  BOOKING_LIST_REQUEST,
  BOOKING_LIST_FAILURE,
  BOOKING_LIST_SUCCESS,
  BOOKING_DETAIL_REQUEST,
  BOOKING_DETAIL_FAILURE,
  BOOKING_DETAIL_SUCCESS,
  CHANGE_BOOKING_DATE,
  CHANGE_MEETING_ROOM,
  EMPLOYEES_PROFILE_REQUEST,
  EMPLOYEES_PROFILE_FAILURE,
  EMPLOYEES_PROFILE_SUCCESS,
  SET_START_TIME,
  UNSET_START_TIME,
  SET_END_TIME,
  UNSET_END_TIME,
  BOOKING_CREATE_REQUEST,
  BOOKING_CREATE_FAILURE,
  BOOKING_CREATE_SUCCESS,
  BOOKING_UPDATE_REQUEST,
  BOOKING_UPDATE_FAILURE,
  BOOKING_UPDATE_SUCCESS,
  BOOKING_DELETE_FAILURE,
  BOOKING_DELETE_SUCCESS,
  BOOKING_DELETE_REQUEST,
  INITIALIZE_ROOM_BOOKING,
  GENERATE_WEEK_ARRAY,
  CHANGE_BOOKING_VIEW_TYPE,
  INTERNAL_MEMBER_INVITE,
  DELETE_REPEAT_MEETING_ROOM_FAILURE,
  DELETE_REPEAT_MEETING_ROOM_SUCCESS,
  DELETE_REPEAT_MEETING_ROOM_REQUEST
}

/**
|--------------------------------------------------
| Actions
|--------------------------------------------------
*/
export const changeMeetingRoom = roomID => ({
  type: CHANGE_MEETING_ROOM,
  roomID
})

export const deleteRepeat = (SeriesID, reasons) => ({
  type: DELETE_REPEAT_MEETING_ROOM_REQUEST,
  SeriesID,
  reasons
})

export const changeBookingDate = bookingDate => ({
  type: CHANGE_BOOKING_DATE,
  bookingDate
})

export const getRoomList = () => ({
  type: ROOM_LIST_REQUEST
})

export const getBookingList = (from, to, meetingRoomID) => ({
  type: BOOKING_LIST_REQUEST,
  from,
  to,
  meetingRoomID
})

export const getEmployeesProfile = textFind => ({
  type: EMPLOYEES_PROFILE_REQUEST,
  textFind
})

export const setStartTime = choosenTime => ({
  type: SET_START_TIME,
  choosenTime
})

export const setEndTime = choosenTime => ({
  type: SET_END_TIME,
  choosenTime
})

export const unsetStartTime = () => ({
  type: UNSET_START_TIME
})

export const unsetEndTime = choosenTime => ({
  type: UNSET_END_TIME,
  choosenTime
})

export const inviteInternal = member => ({
  type: INTERNAL_MEMBER_INVITE,
  member
})

export const removeInternal = member => ({
  type: INTERNAL_MEMBER_REMOVE,
  member
})

export const inviteExternal = member => ({
  type: EXTERNAL_MEMBER_INVITE,
  member
})

export const removeExternal = member => ({
  type: EXTERNAL_MEMBER_REMOVE,
  member
})

export const getBookingDetail = bookingId => ({
  type: BOOKING_DETAIL_REQUEST,
  bookingId
})

export const createBooking = formValues => ({
  type: BOOKING_CREATE_REQUEST,
  formValues
})

export const updateBooking = (formValues, bookingId) => ({
  type: BOOKING_UPDATE_REQUEST,
  formValues,
  bookingId
})

export const initialBookingForm = () => ({
  type: INITIALIZE_ROOM_BOOKING
})

export const deleteBooking = (bookingId, reasons) => ({
  type: BOOKING_DELETE_REQUEST,
  bookingId,
  reasons
})

export const generateWeekArray = dayRange => ({
  type: GENERATE_WEEK_ARRAY,
  dayRange,
  needToRegen: true
})

export const changeViewType = viewType => ({
  type: CHANGE_BOOKING_VIEW_TYPE,
  viewType
})

/**
|--------------------------------------------------
| Handlers
|--------------------------------------------------
*/
const ActionHandler = {
  [CHANGE_MEETING_ROOM]: (currentState, action) => ({
    ...currentState,
    meetingRoomID: action.roomID,
    meetingRoom: currentState.roomList.find(room => room.ID === action.roomID)
  }),
  [ROOM_LIST_SUCCESS]: (currentState, action) => ({
    ...currentState,
    isLoading: false,
    roomList: action.list,
    meetingRoomID: action.meetingRoomID
  }),
  [BOOKING_LIST_REQUEST]: (currentState, action) => ({
    ...currentState,
    isLoading: true,
    bookingList: []
  }),
  [BOOKING_LIST_FAILURE]: (currentState, action) => ({
    ...currentState,
    isLoading: false
  }),
  [BOOKING_LIST_SUCCESS]: (currentState, action) => ({
    ...currentState,
    isLoading: false,
    bookingList: action.items,
    timeline: timelineCalculating({
      dateList: currentState.dateList,
      bookingDate: currentState.bookingDate,
      bookingList: action.items,
      viewType: currentState.viewType
    }),
    timeList: timeListCalculating(
      currentState.bookingDate,
      action.items,
      currentState.startTime,
      currentState.isEdit
    )
  }),
  [SET_START_TIME]: (currentState, action) => ({
    ...currentState,
    startTime: action.choosenTime,
    endTime: 0,
    timeList: timeListCalculating(
      currentState.bookingDate,
      currentState.bookingList,
      action.choosenTime,
      currentState.isEdit
    )
  }),
  [UNSET_START_TIME]: (currentState, action) => ({
    ...currentState,
    startTime: 0,
    endTime: 0
  }),
  [SET_END_TIME]: (currentState, action) => ({
    ...currentState,
    endTime: action.choosenTime
  }),
  [UNSET_END_TIME]: (currentState, action) => ({
    ...currentState,
    endTime: 0
  }),
  [INTERNAL_MEMBER_INVITE]: (currentState, action) => ({
    ...currentState,
    internalMembers: [action.member].concat(
      currentState.internalMembers.filter(
        member => member.Email !== action.member.Email
      )
    ),
    externalMembers: currentState.externalMembers.filter(
      member => member.Email !== action.member.Email
    )
  }),
  [INTERNAL_MEMBER_REMOVE]: (currentState, action) => ({
    ...currentState,
    internalMembers: currentState.internalMembers.filter(
      member => member.Email !== action.member.Email
    )
  }),
  [EXTERNAL_MEMBER_REMOVE]: (currentState, action) => ({
    ...currentState,
    externalMembers: currentState.externalMembers.filter(
      member => member.Email !== action.member.Email
    )
  }),
  [EXTERNAL_MEMBER_INVITE]: (currentState, action) => ({
    ...currentState,
    externalMembers: [action.member].concat(currentState.externalMembers)
  }),
  [EMPLOYEES_PROFILE_SUCCESS]: (currentState, action) => ({
    ...currentState,
    employeesProfile: action.profiles
  }),
  [INITIALIZE_ROOM_BOOKING]: (currentState, action) => ({
    ...currentState,
    isEdit: true,
    internalMembers: [],
    externalMembers: []
  }),
  [BOOKING_DETAIL_REQUEST]: (currentState, action) => ({
    ...currentState,
    isEdit: true,
    isLoading: true,
    internalMembers: [],
    externalMembers: []
  }),
  [BOOKING_DETAIL_SUCCESS]: (currentState, action) => ({
    ...currentState,
    isLoading: false,
    isEdit: action.isEdit,
    internalMembers: action.internalMembers,
    externalMembers: action.externalMembers,
    timeList: timeListCalculating(
      currentState.bookingDate,
      currentState.bookingList,
      currentState.startTime,
      currentState.isEdit
    )
  }),
  [BOOKING_DETAIL_FAILURE]: (currentState, action) => ({
    ...currentState,
    isLoading: false,
    isEdit: false,
    internalMembers: [],
    externalMembers: []
  }),
  [BOOKING_DELETE_SUCCESS]: (currentState, action) => ({
    ...currentState,
    bookingList: currentState.bookingList.filter(
      booking => booking.ID !== action.bookingId
    )
  }),
  [GENERATE_WEEK_ARRAY]: (currentState, action) => ({
    ...currentState,
    isLoading: true,
    dateList: action.needToRegen
      ? getWeekArray(
          addDays(
            action.bookingDate || currentState.dateList[0],
            action.dayRange
          )
        )
      : currentState.dateList,
    bookingDate:
      currentState.viewType === false
        ? addDays(
            action.bookingDate || currentState.bookingDate,
            action.dayRange
          )
        : action.bookingDate || currentState.bookingDate
  }),
  [CHANGE_BOOKING_VIEW_TYPE]: (currentState, action) => ({
    ...currentState,
    viewType: action.viewType,
    timeline: timelineCalculating({
      bookingDate: currentState.bookingDate,
      bookingList: currentState.bookingList,
      dateList: currentState.dateList,
      viewType: !currentState.viewType
    })
  }),
  [BOOKING_CREATE_REQUEST]: (currentState, aciton) => ({
    ...currentState,
    isLoading: true
  }),
  [BOOKING_CREATE_SUCCESS]: (currentState, aciton) => ({
    ...currentState,
    isLoading: false
  }),
  [BOOKING_CREATE_FAILURE]: (currentState, aciton) => ({
    ...currentState,
    isLoading: false
  }),
  [BOOKING_UPDATE_REQUEST]: (currentState, aciton) => ({
    ...currentState,
    isLoading: true
  }),
  [BOOKING_UPDATE_SUCCESS]: (currentState, aciton) => ({
    ...currentState,
    isLoading: false
  }),
  [BOOKING_UPDATE_FAILURE]: (currentState, aciton) => ({
    ...currentState,
    isLoading: false
  }),
  [DELETE_REPEAT_MEETING_ROOM_REQUEST]: (currentState, aciton) => ({
    ...currentState,
    isLoading: true
  }),
  [DELETE_REPEAT_MEETING_ROOM_SUCCESS]: (currentState, aciton) => ({
    ...currentState,
    isLoading: false
  }),
  [DELETE_REPEAT_MEETING_ROOM_FAILURE]: (currentState, aciton) => ({
    ...currentState,
    isLoading: false
  })
}

/**
|--------------------------------------------------
| Reducer
|--------------------------------------------------
*/
const initialState = {
  isLoading: false,
  startTime: 0,
  endTime: 0,
  roomList: [],
  bookingList: [],
  meetingRoom: {},
  meetingRoomID: null,
  bookingDate: new Date(),
  employeesProfile: [],
  internalMembers: [],
  externalMembers: [],
  dateList: getWeekArray(new Date()),
  viewType: true, // Week: true, Day: false
  timeline: [],
  timeList: timeListCalculating(new Date(), []),
  isEdit: true
}

export default function meetingRoomBooking(
  currentState = { ...initialState },
  action
) {
  const handler = ActionHandler[action.type]
  const nextState = handler ? handler(currentState, action) : currentState
  return nextState
}



// WEBPACK FOOTER //
// ./src/routes/MeetingRoomBookingOverview/modules/reducer.js